import abstractModel from "../../core/MercatelyModel";

const resource = '/api/mia/chatbot/instructions';

const model = abstractModel(resource);

export default model;
